import axios from 'axios';

// Use backend base URL from environment variable
const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';

// Get auth token from localStorage (for compatibility)
const getAuthToken = () => {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};

// Configure axios to send cookies (for PHP session)
axios.defaults.withCredentials = true;

// Get current user info from PHP session
export const getCurrentUser = async () => {
  try {
    const response = await axios.get(`${API_BASE}/api/approvals/current-user`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mendapatkan info user' };
  }
};

// Get pending approvals for current user (filtered by role)
export const getPendingApprovals = async () => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/approvals/pending`,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil data approval' };
  }
};

// Review booking with risk evaluation
export const reviewBooking = async (bookingId) => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/approvals/review/${bookingId}`,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal review booking' };
  }
};

// Approve booking at current stage
export const approveBooking = async (approvalId) => {
  try {
    const response = await axios.post(
      `${API_BASE}/api/approvals/approve/${approvalId}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal approve booking' };
  }
};

// Reject booking with reason
export const rejectBooking = async (approvalId, rejectionReason) => {
  try {
    const response = await axios.post(
      `${API_BASE}/api/approvals/reject/${approvalId}`,
      { rejection_reason: rejectionReason },
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal reject booking' };
  }
};

// Get approval history for a booking
export const getApprovalHistory = async (bookingId) => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/approvals/history/${bookingId}`,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal mengambil approval history' };
  }
};

// Request price override (creates approval workflow)
export const requestPriceOverride = async (overrideData) => {
  try {
    const response = await axios.post(
      `${API_BASE}/api/approvals/price-override`,
      overrideData,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Gagal request price override' };
  }
};
